
<template>
    <div id="movie-manage">
      <!--搜索-->
      <div class="top">
        <el-col :span="12">
          <el-input placeholder="请输入内容" v-model="input" class="input-with-select" style="width: 100%">
            <el-button slot="append" icon="el-icon-search" @click="search">搜索</el-button>
          </el-input>
        </el-col>
        <el-col :span="2" :offset="1">
          <el-button type="primary" size="small" @click="addMovie">添加文章</el-button>
        </el-col>
      </div>
      <!--表格-->
      <div class="order-table">
      <el-table
        border
        :data="tableData"
        style="width: 100%">
        <el-table-column label="文章 ID" align="center" width="110"  prop="id">
          <template slot-scope="scope">
            <span  @click="handleArtClick_word(scope.row)" :style="{ color: scope.row.word === 1 ? 'blue' : 'red' }">{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="文章标题"
          width="200"
          align="center"
          show-overflow-tooltip
          prop="name">
        </el-table-column>
        <el-table-column
          label="发布时间"
          width="110"
          show-overflow-tooltip
          prop="created_at">
        </el-table-column>
        <el-table-column
            label="当前状态"
            width="110"
            show-overflow-tooltip
            prop="status"
          >
            <template slot-scope="{ row }">
              <span :style="{ color: row.status === 1 ? 'green' : 'red' }">
                {{ row.status === 1 ? '启用' : '停用' }}
              </span>
            </template>
          </el-table-column>

        <el-table-column
          label="文章类型"
          width="120"
          show-overflow-tooltip
          align="center"
          prop="atype">
        </el-table-column>
        <el-table-column
          label="是否置顶"
          width="150"
          align="center"
          show-overflow-tooltip
          prop="top">
        </el-table-column>
        <el-table-column
        width="100"
        align="center"
        label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column label="置顶操作"    align="center" min-width="20%" width="110">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleTop( scope.row)">置顶/取消</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
      <!--分页-->
      <div class="block" v-if="tableData.length">
      <el-pagination
        @current-change="currentChange"
        background
        layout="prev, pager, next"
        :page-size="8"
        :page-count="total">
      </el-pagination>
    </div>
      <!--弹框-->
      <div>
        <el-dialog
          :title="dialogTitle"
          :visible.sync="dialogFormVisible"
          :modal-append-to-body="false"
          v-if="dialogFormVisible"
          :showClose="false"
        >
          <el-form :label-position="labelPosition" label-width="80px" :model="snackInfo">
            <el-form-item label="封面图片" prop="img">
              <el-col :span="16">
                <el-upload
                  class="upload-btn"
                  :action="uploadUrl"
                  :show-file-list="false"
                  :http-request="httpRequest" >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <img :src="fileUrl" alt="封面图片" style="max-width: 10%; max-height: 10%;" v-if="fileUrl" />
              </el-col>
            </el-form-item>
            <el-form-item label="文章类型" prop="cinemaNm">
            <el-col :span="12">
              <el-select v-model="snackInfo.atype" placeholder="选择文章类型" >
                <el-option label="最新解读" value="1"></el-option>
                <el-option label="产业解读" value="0"></el-option>
              </el-select>
            </el-col>
            </el-form-item>
            <el-form-item label="文章名称" >
              <el-col :span="16">
                <el-input v-model="snackInfo.name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="文章链接" placeholder="输入微信公众号原文链接" >
              <el-col :span="16">
                <el-input v-model="snackInfo.url"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="文章标签" prop="price">
              <el-col :span="16">
                <el-input v-model="snackInfo.tags"></el-input>
              </el-col>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="manageSnackInfo()">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
</template>

<script>
    import {getCurrentPageOrder,deleteOrder,topOrder,UpdateWord} from '../../../api/index'
    import {MessageBox,Message} from 'element-ui'
    import axios from "axios";
import { tr } from 'element-plus/es/locales.mjs';
    export default {
        name: "OrderManage",
        data(){
          return{
            tableData:[],
            total:0,
            currentPage:1,
            dialogFormVisible:false,
            dialogTitle:'',
            labelPosition:'left',
            input:'',
            searchInput:'',
            fileUrl:'',
            snackInfo:{},
          }
        },
        created() {
          this.loadCurrentPageOrder(this.currentPage,8,'');
          this.uploadUrl = 'https://www.windustry.cn/admin/image/upload'
        },
        methods:{
          async loadCurrentPageOrder(currentPage,pageSize,input){
            let json = await getCurrentPageOrder(currentPage,pageSize,input);
            if (json.code===200){
              this.tableData = json.data;
              this.total = Math.ceil(json.total / 10);
            }
          },
          async currentChange(currentPage){
            this.currentPage = currentPage;
            this.loadCurrentPageOrder(this.currentPage,8,this.searchInput);
          },
          async handleArtClick_word(row)
            {
            this.snackInfo= row
            this.fileUrl = row.image
            this.dialogFormVisible = true

          },
          async addMovie(){

            this.dialogTitle = '添加文章';
            this.snackInfo = {"id":"news"};
            this.dialogFormVisible = true;
          },
          //搜索订单
          search(){
            this.searchInput = this.input;
            this.loadCurrentPageOrder(1,8,this.searchInput);
          },
          async handleDelete( row) {
            MessageBox.confirm('此操作将永久删除该文章信息, 是否继续？','提示').then(async (value)=>{
              if (value==='confirm'){
                let json = await deleteOrder(row.id);
                if (json.code===200){
                  Message.success('删除成功！');
                  this.loadCurrentPageOrder(this.currentPage,8,this.searchInput);
                }
              }
            });
            console.log(index, row);
          },
          async handleTop(row){
            MessageBox.confirm('此操作将置顶该文章信息, 是否继续？','提示').then(async (value)=>{
              if (value==='confirm'){
                let json = await  topOrder(row.id);
                if (json.code===200){
                  Message.success('置顶成功！');
                  this.loadCurrentPageOrder(this.currentPage,8,this.searchInput);
                }
              }
            });
            console.log(index, row);
          },
          async manageSnackInfo(){
            this.snackInfo.image = this.fileUrl
            let json = await  UpdateWord(this.snackInfo);
            if (json.code===200){
                  Message.success('更新添加成功！');
                  this.loadCurrentPageOrder(this.currentPage,8,this.searchInput);
                  this.dialogFormVisible = false
            }
            else {
              Message.error('更新添加失败！')
            }
          },
          cancel(){
            this.dialogFormVisible = false;
            this.loadCurrentPageOrder(1,8,'');
          },
          //上传图片
          httpRequest(op) {
              const formData = new FormData();
              formData.append('file', op.file);

              axios.post('https://www.windustry.cn/admin/image/upload', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(response => {
                let json  = response.data; // 从响应中获取数据;
                if (json.code===200){
                    Message.success('上传成功')
                    this.fileurl = json.url
                    this.fileUrl = json.url
                  }
              })
              .catch(error => {
                // 处理上传失败的逻辑
                 Message.error('上传失败，请重试')
              });

            },
        }
    }
</script>

<style>
  .movie-table{
    width:90%;
    min-width:900px;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .top{
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 30px 0; */
    margin-bottom: 30px;
  }
  .block{
    text-align: center;
  }
  .el-dialog__header{
    text-align: center;
  }
  .el-dialog__body .el-form-item{
    padding-left: 20%;
  }
.upload-imgs{margin: 10px 0 30px 0;overflow: hidden;font-size: 0;}
.upload-imgs li{position: relative;width: 150px;height: 90px;font-size: 14px;display: inline-block;margin-right: 25px;text-align: center;vertical-align: middle;}
.upload-imgs .img{position: relative;width: 94px;height: 94px;line-height: 94px;}
.upload-imgs .img img{vertical-align: middle;}
.upload-imgs .img .close{display: none;}
.upload-imgs li:hover .img .close{display: block;position: absolute;right: -50px;top: 5px;line-height: 1;font-size: 22px;color: #fff;}
</style>



// WEBPACK FOOTER //
// src/pages/Home/children/OrderManage.vue